import React from "react";
import type { GatsbyBrowser } from "gatsby";
import Root from "./src/layouts/partials/root";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = (props) => (
  <Root {...props}>{props.element}</Root>
);
